export default __webpack_public_path__ + "static/alibris-08c00275d769cf630e509a6cdbde99e6.png";